// Chapter 8 writing frames ("מסגרות"), uploaded 1.11.2026 (Shlomo reviews them live on the site).
// One frame per step; all work on the single event the reader names in step 1.
// Mounted by App.tsx (FrameBox) at <div data-widget-anchor="ch8_fN"> in src/chapters/chapter-8.html.
// Answers persist in progress.fields under `${id}_${i}` (or `_c1`/`_c2` for two columns).
import type { Frame } from "./frames";

export const CH8_FRAMES: Frame[] = [
  {
    "id": "ch8_f1",
    "n": "8.1",
    "title": "הרגע האדום שלי",
    "type": "lines",
    "intro": "עובדות בלבד, בלי שיפוט. אין תשובה נכונה.",
    "fields": [
      "השם שנתתי לו:",
      "מה קרה (מה שמצלמה הייתה רואה):",
      "הרגש שעלה, ובאיזו עוצמה (1-10):",
      "ממה הוא ינק, פחד או אהבה, ומה הפחד אמר:"
    ]
  },
  {
    "id": "ch8_f2",
    "n": "8.2",
    "title": "מה הפחד אמר, מה האהבה אומרת",
    "type": "twocol",
    "intro": "",
    "fields": [
      "מה הפחד אמר ברגע|מה האהבה הייתה אומרת על אותו רגע"
    ]
  },
  {
    "id": "ch8_f3",
    "n": "8.3",
    "title": "יומן השאלה",
    "type": "scale2",
    "intro": "1 = בקושי הרגשתי, 10 = הציף אותי.",
    "fields": [
      "עוצמת הרגש לפני ששאלתי",
      "עוצמת הרגש אחרי ששאלתי",
      "רגע אחד מהשבוע (יום, מה קרה, מה השאלה עשתה):"
    ]
  },
  {
    "id": "ch8_f4",
    "n": "8.4",
    "title": "הרגע שלי ו-11 האינטליגנציות",
    "type": "lines",
    "intro": "",
    "fields": [
      "האינטליגנציה שהרגע שלי דרש (מהרשימה):",
      "האינטליגנציה שבה אני חזקה שהייתה יכולה לעזור שם:",
      "האדם האחר ברגע: במה הוא כנראה חזק ואני פחות, או להפך (אי-הבנה, לא אי-הסכמה):"
    ]
  },
  {
    "id": "ch8_f5",
    "n": "8.5",
    "title": "טבלאות האינטליגנציות",
    "type": "existing",
    "intro": "שורה אחת מתחת לשתי הטבלאות שמילאת:",
    "fields": [
      "האינטליגנציה מהטבלאות שהכי קשורה לרגע שלי (חוזקה / חולשה), ומה אעשה איתה:"
    ]
  },
  {
    "id": "ch8_f6",
    "n": "8.6",
    "title": "הלך הרוח שלי בשעה שלפני",
    "type": "scale2",
    "intro": "1 = אדום לגמרי, 10 = ירוק לגמרי.",
    "fields": [
      "הלך הרוח שלי בשעה שלפני הרגע",
      "שני דברים שקבעו אותו (שינה / אוכל / שיחה / אירוע קודם / סוף יום):"
    ]
  },
  {
    "id": "ch8_f7",
    "n": "8.7",
    "title": "טבלאות אי-הקבלה",
    "type": "existing",
    "intro": "שתי שורות מתחת לטבלאות שמילאת. ברגע האדום הייתי הכי טובה שלי, בגלל:",
    "fields": [
      "המשתנים שלי באותה שנייה (שינה / רעב / לחץ / מה קרה לפני):",
      "המשתנים שלו או שלה, כנראה:"
    ]
  },
  {
    "id": "ch8_f8",
    "n": "8.8",
    "title": "מה אמרתי לעצמי, ומה אומר",
    "type": "lines",
    "intro": "",
    "fields": [
      "המשפט שאמרתי לעצמי אחרי הרגע (במדויק):",
      "אותו משפט, מתוך \"הייתי הכי טובה שלי\":"
    ]
  },
  {
    "id": "ch8_f9",
    "n": "8.9",
    "title": "טבלת רוצה-צריך",
    "type": "existing",
    "intro": "שורה אחת מתחת לטבלה שמילאת:",
    "fields": [
      "ה\"צריך\" שישב בתוך הרגע שלי, כתוב מחדש: \"אני רוצה ..., כי ...\":"
    ]
  },
  {
    "id": "ch8_f10",
    "n": "8.10",
    "title": "הגוף ברגע, והחזרה",
    "type": "lines",
    "intro": "",
    "fields": [
      "מה הגוף שלי עשה ברגע (דופק / נשימה / בטן / כתפיים / קול):",
      "כמה זמן לקח לו לחזור (דקות / שעות / עוד לא לגמרי):",
      "הסימן הראשון בגוף לפעם הבאה, לפני שהראש מבין (הסימן שכתבת בפרק 3 - עדיין אותו, או שהפעם הגיע סימן אחר?):"
    ]
  },
  {
    "id": "ch8_f11",
    "n": "8.11",
    "title": "הרגע שלי, מתוך אהבה",
    "type": "final",
    "intro": "",
    "fields": [
      "התרגול שלי לשבוע (נשיפה ארוכה / הליכה / מים קרים / שירה / צחוק / מגע):",
      "הרגע האדום שלי, פעם שנייה (שלוש שורות, מתוך אהבה):",
      "",
      "",
      "המשפט שלי לפעם הבאה שהאדום יעלה:"
    ]
  }
];
